import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import File from "../../../services/File";
import CloseIcon from "../../shared/icons/CloseIcon";
import { toast } from "react-toastify";
import { t } from "i18next";

const DepositModal = ({ onClose }) => {

    const [price, setPrice] = useState('');
    const [errorTitlePrice, setErrorTitlePrice] = useState();

    const handlePriceChange = (event) => {
        setPrice(event.target.value);
    };

    useEffect(() => {
        if (price) {
            setErrorTitlePrice('');
        }
    }, [price]);

    const downloadDepositDoc = () => {
        const numericPrice = Number(price);
        if (!numericPrice || numericPrice === 0) {
            setErrorTitlePrice("Сумма не должен быть пустым или равен нулю");
            return;
        }
        File.getDocDeposit(price)
            .then(response => {
                toast.success(t('orderInfo.ordersInfoHeader.copySuccess'));
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const currentDate = new Date();
                const formattedDate = currentDate.toISOString().split('T')[0];

                link.setAttribute('download', `invoice-${formattedDate}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                onClose()
            })
            .catch(error => {
                console.error("Ошибка при скачивании документа:", error);
            });
    };

    return (
        <>
            <div className="modal-overlay">
                <div style={{
                    backgroundColor: "#ffffff",
                    height: "auto",
                    width: "max-content",
                    margin: "100px auto",
                    borderRadius: "6px",
                    padding: "20px 25px",
                }}>
                    <div style={{
                        position: "relative"
                    }}>
                        <CloseIcon width={20} height={20} onClick={() => { onClose() }} fill={'#909195'}
                            style={{
                                position: 'absolute',
                                top: "-10px",
                                right: "-10px",
                            }}
                        />
                        <div className="input">
                            <Form.Label>{t('balanceList.writeSum')}</Form.Label>
                            <Form.Control value={price}
                                onChange={handlePriceChange}
                                size="lg"
                                type="number"
                                placeholder={t('balanceList.writeSum')}
                            />
                            {errorTitlePrice && (
                                <div style={{ fontSize: "13px", color: "red", padding: "5px 0 0", }}>
                                    {errorTitlePrice}
                                </div>
                            )}
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: "10px" }}>
                        <Button style={{ width: '200px', marginRight: '20px' }} variant="outline-primary" onClick={() => {
                            downloadDepositDoc()
                        }}>{t('balanceList.download')}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DepositModal;
